let elements = {
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page056_game1/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: { click: 'games/page056_game1/audio/click.mp3' },
  pick: 20,
  // progressBar: {
  //   cssStyle: {
  //     left: '840px',
  //     bottom: '0',
  //     width: '240px',
  //     height: '122px',
  //   },
  //   image: {
  //     0: 'games/page056_game1/img/0.png',
  //     1: 'games/page056_game1/img/1.png',
  //     2: 'games/page056_game1/img/2.png',
  //     3: 'games/page056_game1/img/3.png',
  //   },
  // },
  items: [
    // rabbit
    {
      id: 'i1',
      linkedId: 'i21',
      audioSrc: 'games/page056_game0/audio/5_rabbit.mp3',
      image: {
        pos: {
          x: 32,
          y: 297,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/rabbit_tr.png',
      },
      mask: {
        pos: {
          x: 32,
          y: 297,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i21',
      linkedId: 'i1',
      audioSrc: 'games/page056_game0/audio/5_rabbit.mp3',
      image: {
        pos: {
          x: 934,
          y: 752,
        },
        width: 115,
        height: 144,
        src: 'games/page056_game1/img/rabbit2_tr.png',
      },
      mask: {
        pos: {
          x: 934,
          y: 752,
        },
        width: 115,
        height: 144,
        src: 'games/page056_game1/img/rabbit.gif',
      },
    },
    // mole
    {
      id: 'i2',
      linkedId: 'i22',
      audioSrc: 'games/page056_game0/audio/7_mole.mp3',
      image: {
        pos: {
          x: 190,
          y: 305,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/mole_tr.png',
      },
      mask: {
        pos: {
          x: 190,
          y: 305,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i22',
      linkedId: 'i2',
      audioSrc: 'games/page056_game0/audio/7_mole.mp3',
      image: {
        pos: {
          x: 989,
          y: 442,
        },
        width: 109,
        height: 100,
        src: 'games/page056_game1/img/mole2_tr.png',
      },
      mask: {
        pos: {
          x: 989,
          y: 442,
        },
        width: 109,
        height: 100,
        src: 'games/page056_game1/img/mole.gif',
      },
    },
    // purple
    {
      id: 'i3',
      linkedId: 'i23',
      audioSrc: 'games/page056_game0/audio/12_purple.mp3',
      image: {
        pos: {
          x: 350,
          y: 411,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/purple_tr.png',
      },
      mask: {
        pos: {
          x: 350,
          y: 411,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i23',
      linkedId: 'i3',
      audioSrc: 'games/page056_game0/audio/12_purple.mp3',
      image: {
        pos: {
          x: 559,
          y: 560,
        },
        width: 86,
        height: 82,
        src: 'games/page056_game1/img/purple2_tr.png',
      },
      mask: {
        pos: {
          x: 559,
          y: 560,
        },
        width: 86,
        height: 82,
        src: 'games/page056_game1/img/purple.gif',
      },
    },
    // orange
    {
      id: 'i4',
      linkedId: 'i24',
      audioSrc: 'games/page056_game0/audio/14_orange.mp3',
      image: {
        pos: {
          x: 196,
          y: 410,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/orange_tr.png',
      },
      mask: {
        pos: {
          x: 196,
          y: 410,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i24',
      linkedId: 'i4',
      audioSrc: 'games/page056_game0/audio/14_orange.mp3',
      image: {
        pos: {
          x: 726,
          y: 506,
        },
        width: 95,
        height: 83,
        src: 'games/page056_game1/img/orange2_tr.png',
      },
      mask: {
        pos: {
          x: 726,
          y: 506,
        },
        width: 95,
        height: 83,
        src: 'games/page056_game1/img/orange.gif',
      },
    },
    // calm
    {
      id: 'i5',
      linkedId: 'i25',
      audioSrc: 'games/page056_game0/audio/17_calm.mp3',
      image: {
        pos: {
          x: 349,
          y: 515,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/calm_tr.png',
      },
      mask: {
        pos: {
          x: 349,
          y: 515,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i25',
      linkedId: 'i5',
      audioSrc: 'games/page056_game0/audio/17_calm.mp3',
      image: {
        pos: {
          x: 1293,
          y: 271,
        },
        width: 89,
        height: 93,
        src: 'games/page056_game1/img/calm2_tr.png',
      },
      mask: {
        pos: {
          x: 1293,
          y: 271,
        },
        width: 89,
        height: 93,
        src: 'games/page056_game1/img/calm.gif',
      },
    },
    // angry
    {
      id: 'i6',
      linkedId: 'i26',
      audioSrc: 'games/page056_game0/audio/18_angry.mp3',
      image: {
        pos: {
          x: 196,
          y: 515,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/angry_tr.png',
      },
      mask: {
        pos: {
          x: 196,
          y: 515,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i26',
      linkedId: 'i6',
      audioSrc: 'games/page056_game0/audio/18_angry.mp3',
      image: {
        pos: {
          x: 1210,
          y: 789,
        },
        width: 84,
        height: 106,
        src: 'games/page056_game1/img/angry2_tr.png',
      },
      mask: {
        pos: {
          x: 1210,
          y: 789,
        },
        width: 84,
        height: 106,
        src: 'games/page056_game1/img/angry.gif',
      },
    },
    // sister
    {
      id: 'i7',
      linkedId: 'i27',
      audioSrc: 'games/page056_game0/audio/24_sister.mp3',
      image: {
        pos: {
          x: 353,
          y: 623,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/sister_tr.png',
      },
      mask: {
        pos: {
          x: 353,
          y: 623,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i27',
      linkedId: 'i7',
      audioSrc: 'games/page056_game0/audio/24_sister.mp3',
      image: {
        pos: {
          x: 639,
          y: 270,
        },
        width: 109,
        height: 113,
        src: 'games/page056_game1/img/sister2_tr.png',
      },
      mask: {
        pos: {
          x: 639,
          y: 270,
        },
        width: 109,
        height: 113,
        src: 'games/page056_game1/img/sister.gif',
      },
    },
    // grandma
    {
      id: 'i8',
      linkedId: 'i28',
      audioSrc: 'games/page056_game0/audio/27_grandma.mp3',
      image: {
        pos: {
          x: 30,
          y: 623,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/grandma_tr.png',
      },
      mask: {
        pos: {
          x: 30,
          y: 623,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i28',
      linkedId: 'i8',
      audioSrc: 'games/page056_game0/audio/27_grandma.mp3',
      image: {
        pos: {
          x: 1115,
          y: 388,
        },
        width: 84,
        height: 166,
        src: 'games/page056_game1/img/grandma2_tr.png',
      },
      mask: {
        pos: {
          x: 1115,
          y: 388,
        },
        width: 84,
        height: 166,
        src: 'games/page056_game1/img/grandma.gif',
      },
    },
    // robot
    {
      id: 'i9',
      linkedId: 'i29',
      audioSrc: 'games/page056_game0/audio/32_robot.mp3',
      image: {
        pos: {
          x: 356,
          y: 727,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/robot_tr.png',
      },
      mask: {
        pos: {
          x: 356,
          y: 727,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i29',
      linkedId: 'i9',
      audioSrc: 'games/page056_game0/audio/32_robot.mp3',
      image: {
        pos: {
          x: 987,
          y: 667,
        },
        width: 130,
        height: 128,
        src: 'games/page056_game1/img/robot2_tr.png',
      },
      mask: {
        pos: {
          x: 987,
          y: 667,
        },
        width: 130,
        height: 128,
        src: 'games/page056_game1/img/robot.gif',
      },
    },
    // three
    {
      id: 'i10',
      linkedId: 'i30',
      audioSrc: 'games/page056_game0/audio/35_three.mp3',
      image: {
        pos: {
          x: 202,
          y: 727,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/three_tr.png',
      },
      mask: {
        pos: {
          x: 202,
          y: 727,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i30',
      linkedId: 'i10',
      audioSrc: 'games/page056_game0/audio/35_three.mp3',
      image: {
        pos: {
          x: 824,
          y: 269,
        },
        width: 88,
        height: 97,
        src: 'games/page056_game1/img/three2_tr.png',
      },
      mask: {
        pos: {
          x: 824,
          y: 269,
        },
        width: 88,
        height: 97,
        src: 'games/page056_game1/img/three.gif',
      },
    },
    // sing
    {
      id: 'i11',
      linkedId: 'i31',
      audioSrc: 'games/page056_game0/audio/36_sing.mp3',
      image: {
        pos: {
          x: 1456,
          y: 304,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/sing_tr.png',
      },
      mask: {
        pos: {
          x: 1456,
          y: 304,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i31',
      linkedId: 'i11',
      audioSrc: 'games/page056_game0/audio/36_sing.mp3',
      image: {
        pos: {
          x: 1169,
          y: 268,
        },
        width: 109,
        height: 140,
        src: 'games/page056_game1/img/sing2_tr.png',
      },
      mask: {
        pos: {
          x: 1169,
          y: 268,
        },
        width: 109,
        height: 140,
        src: 'games/page056_game1/img/sing.gif',
      },
    },
    // paint
    {
      id: 'i12',
      linkedId: 'i32',
      audioSrc: 'games/page056_game0/audio/41_paint.mp3',
      image: {
        pos: {
          x: 1609,
          y: 304,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/paint_tr.png',
      },
      mask: {
        pos: {
          x: 1609,
          y: 304,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i32',
      linkedId: 'i12',
      audioSrc: 'games/page056_game0/audio/41_paint.mp3',
      image: {
        pos: {
          x: 652,
          y: 685,
        },
        width: 143,
        height: 159,
        src: 'games/page056_game1/img/paint2_tr.png',
      },
      mask: {
        pos: {
          x: 652,
          y: 685,
        },
        width: 143,
        height: 159,
        src: 'games/page056_game1/img/paint.gif',
      },
    },
    // lemon
    {
      id: 'i13',
      linkedId: 'i33',
      audioSrc: 'games/page056_game0/audio/46_lemon.mp3',
      image: {
        pos: {
          x: 1774,
          y: 411,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/lemon_tr.png',
      },
      mask: {
        pos: {
          x: 1774,
          y: 411,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i33',
      linkedId: 'i13',
      audioSrc: 'games/page056_game0/audio/46_lemon.mp3',
      image: {
        pos: {
          x: 831,
          y: 388,
        },
        width: 72,
        height: 67,
        src: 'games/page056_game1/img/lemon2_tr.png',
      },
      mask: {
        pos: {
          x: 831,
          y: 388,
        },
        width: 72,
        height: 67,
        src: 'games/page056_game1/img/lemon.gif',
      },
    },
    // tomato
    {
      id: 'i14',
      linkedId: 'i34',
      audioSrc: 'games/page056_game0/audio/49_tomato.mp3',
      image: {
        pos: {
          x: 1606,
          y: 411,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/tomato_tr.png',
      },
      mask: {
        pos: {
          x: 1606,
          y: 411,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i34',
      linkedId: 'i14',
      audioSrc: 'games/page056_game0/audio/49_tomato.mp3',
      image: {
        pos: {
          x: 1083,
          y: 313,
        },
        width: 75,
        height: 75,
        src: 'games/page056_game1/img/tomato2_tr.png',
      },
      mask: {
        pos: {
          x: 1083,
          y: 313,
        },
        width: 75,
        height: 75,
        src: 'games/page056_game1/img/tomato.gif',
      },
    },
    // cat
    {
      id: 'i15',
      linkedId: 'i35',
      audioSrc: 'games/page056_game0/audio/51_cat.mp3',
      image: {
        pos: {
          x: 1772,
          y: 519,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/cat_tr.png',
      },
      mask: {
        pos: {
          x: 1772,
          y: 519,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i35',
      linkedId: 'i15',
      audioSrc: 'games/page056_game0/audio/51_cat.mp3',
      image: {
        pos: {
          x: 724,
          y: 372,
        },
        width: 105,
        height: 107,
        src: 'games/page056_game1/img/cat2_tr.png',
      },
      mask: {
        pos: {
          x: 724,
          y: 372,
        },
        width: 105,
        height: 107,
        src: 'games/page056_game1/img/cat.gif',
      },
    },
    // canary
    {
      id: 'i16',
      linkedId: 'i36',
      audioSrc: 'games/page056_game0/audio/56_canary.mp3',
      image: {
        pos: {
          x: 1460,
          y: 519,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/canary_tr.png',
      },
      mask: {
        pos: {
          x: 1460,
          y: 519,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i36',
      linkedId: 'i16',
      audioSrc: 'games/page056_game0/audio/56_canary.mp3',
      image: {
        pos: {
          x: 1042,
          y: 369,
        },
        width: 82,
        height: 75,
        src: 'games/page056_game1/img/canary2_tr.png',
      },
      mask: {
        pos: {
          x: 1042,
          y: 369,
        },
        width: 82,
        height: 75,
        src: 'games/page056_game1/img/canary.gif',
      },
    },
    // pat
    {
      id: 'i17',
      linkedId: 'i37',
      audioSrc: 'games/page056_game0/audio/63_pat.mp3',
      image: {
        pos: {
          x: 1784,
          y: 622,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/pat_tr.png',
      },
      mask: {
        pos: {
          x: 1784,
          y: 622,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i37',
      linkedId: 'i17',
      audioSrc: 'games/page056_game0/audio/63_pat.mp3',
      image: {
        pos: {
          x: 1144,
          y: 661,
        },
        width: 145,
        height: 128,
        src: 'games/page056_game1/img/pat2_tr.png',
      },
      mask: {
        pos: {
          x: 1144,
          y: 661,
        },
        width: 145,
        height: 128,
        src: 'games/page056_game1/img/pat.gif',
      },
    },
    // head
    {
      id: 'i18',
      linkedId: 'i38',
      audioSrc: 'games/page056_game0/audio/59_head.mp3',
      image: {
        pos: {
          x: 1615,
          y: 623,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/head_tr.png',
      },
      mask: {
        pos: {
          x: 1615,
          y: 623,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i38',
      linkedId: 'i18',
      audioSrc: 'games/page056_game0/audio/59_head.mp3',
      image: {
        pos: {
          x: 532,
          y: 799,
        },
        width: 125,
        height: 107,
        src: 'games/page056_game1/img/head2_tr.png',
      },
      mask: {
        pos: {
          x: 532,
          y: 799,
        },
        width: 125,
        height: 107,
        src: 'games/page056_game1/img/head.gif',
      },
    },
    // dress
    {
      id: 'i19',
      linkedId: 'i39',
      audioSrc: 'games/page056_game0/audio/66_dress.mp3',
      image: {
        pos: {
          x: 1786,
          y: 728,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/dress_tr.png',
      },
      mask: {
        pos: {
          x: 1786,
          y: 728,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i39',
      linkedId: 'i19',
      audioSrc: 'games/page056_game0/audio/66_dress.mp3',
      image: {
        pos: {
          x: 995,
          y: 552,
        },
        width: 113,
        height: 120,
        src: 'games/page056_game1/img/dress2_tr.png',
      },
      mask: {
        pos: {
          x: 995,
          y: 552,
        },
        width: 113,
        height: 120,
        src: 'games/page056_game1/img/dress.gif',
      },
    },
    // jacket
    {
      id: 'i20',
      linkedId: 'i40',
      audioSrc: 'games/page056_game0/audio/68_jacket.mp3',
      image: {
        pos: {
          x: 1457,
          y: 727,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/jacket_tr.png',
      },
      mask: {
        pos: {
          x: 1457,
          y: 727,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/green.png',
      },
    },
    {
      id: 'i40',
      linkedId: 'i20',
      audioSrc: 'games/page056_game0/audio/68_jacket.mp3',
      image: {
        pos: {
          x: 918,
          y: 274,
        },
        width: 103,
        height: 105,
        src: 'games/page056_game1/img/jacket2_tr.png',
      },
      mask: {
        pos: {
          x: 918,
          y: 274,
        },
        width: 103,
        height: 105,
        src: 'games/page056_game1/img/jacket.gif',
      },
    },
    // 1
    {
      id: 'i41',
      different: false,
      audioSrc: 'games/page056_game0/audio/false.mp3',
      image: {
        pos: {
          x: 348,
          y: 304,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/1.png',
      },
      mask: {
        pos: {
          x: 348,
          y: 304,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/red.png',
      },
    },
    // 2
    {
      id: 'i42',
      different: false,
      audioSrc: 'games/page056_game0/audio/false.mp3',
      image: {
        pos: {
          x: 28,
          y: 409,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/2.png',
      },
      mask: {
        pos: {
          x: 28,
          y: 409,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/red.png',
      },
    },
    // 3
    {
      id: 'i43',
      different: false,
      audioSrc: 'games/page056_game0/audio/false.mp3',
      image: {
        pos: {
          x: 37,
          y: 519,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/3.png',
      },
      mask: {
        pos: {
          x: 37,
          y: 519,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/red.png',
      },
    },
    // 4
    {
      id: 'i44',
      different: false,
      audioSrc: 'games/page056_game0/audio/false.mp3',
      image: {
        pos: {
          x: 200,
          y: 623,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/4.png',
      },
      mask: {
        pos: {
          x: 200,
          y: 623,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/red.png',
      },
    },
    // 5
    {
      id: 'i45',
      different: false,
      audioSrc: 'games/page056_game0/audio/false.mp3',
      image: {
        pos: {
          x: 33,
          y: 727,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/5.png',
      },
      mask: {
        pos: {
          x: 33,
          y: 727,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/red.png',
      },
    },
    // 6
    {
      id: 'i46',
      different: false,
      audioSrc: 'games/page056_game0/audio/false.mp3',
      image: {
        pos: {
          x: 1775,
          y: 304,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/6.png',
      },
      mask: {
        pos: {
          x: 1775,
          y: 304,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/red.png',
      },
    },
    // 7
    {
      id: 'i47',
      different: false,
      audioSrc: 'games/page056_game0/audio/false.mp3',
      image: {
        pos: {
          x: 1457,
          y: 409,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/7.png',
      },
      mask: {
        pos: {
          x: 1457,
          y: 409,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/red.png',
      },
    },
    // 8
    {
      id: 'i48',
      different: false,
      audioSrc: 'games/page056_game0/audio/false.mp3',
      image: {
        pos: {
          x: 1606,
          y: 517,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/8.png',
      },
      mask: {
        pos: {
          x: 1606,
          y: 517,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/red.png',
      },
    },
    // 9
    {
      id: 'i49',
      different: false,
      audioSrc: 'games/page056_game0/audio/false.mp3',
      image: {
        pos: {
          x: 1462,
          y: 625,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/9.png',
      },
      mask: {
        pos: {
          x: 1462,
          y: 625,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/red.png',
      },
    },
    // 10
    {
      id: 'i50',
      different: false,
      audioSrc: 'games/page056_game0/audio/false.mp3',
      image: {
        pos: {
          x: 1614,
          y: 729,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/10.png',
      },
      mask: {
        pos: {
          x: 1614,
          y: 729,
        },
        width: 104,
        height: 104,
        src: 'games/page056_game1/img/red.png',
      },
    },
  ],
};

export default elements;
